import React from "react";
import StackedBarChartCard from "../StackedBarChartCard";

const HEIGHT_BY_SPAN = {
  hero: 380,
  full: 360,
  major: 340,
  half: 320,
  third: 300,
  quarter: 260,
};

const Cell = ({ span = "half", children }) => (
  <div className={`rdc-chart-grid__cell rdc-chart-grid__cell--${span}`}>
    {React.cloneElement(children, { chartHeight: HEIGHT_BY_SPAN[span] || 320 })}
  </div>
);

const DashboardCharts = ({
  decode,
  managerID,
  selectedStartDate,
  selectedEndDate,
  selectedProperty,
}) => {
  const role = decode.role;
  const sharedProps = {
    propertyManagerID: managerID.value,
    selectedStartDate,
    selectedEndDate,
    selectedProperty,
  };

  const showApplicationGroup =
    !(role === "manager" && !decode.applicationPrivilege);
  const showTicketChart = !(role === "manager" && !decode.ticketPrivilege);
  const showLeads =
    role === "company" && decode.domain === "https://www.gskproperties.ca/";
  const showProperty = role === "company" || role === "manager";
  const showPropertyManager = role === "company";
  const showAppointments = !(
    (role === "manager" && !decode.calendarPrivilege) ||
    role === "admin"
  );

  return (
    <div className="rdc-chart-grid">
      {showApplicationGroup && (
        <Cell span="hero">
          <StackedBarChartCard
            type="applicant"
            title="Applications"
            {...sharedProps}
          />
        </Cell>
      )}

      {showApplicationGroup && (
        <Cell span="half">
          <StackedBarChartCard
            type="ticket2"
            title="Maintenance Requests"
            {...sharedProps}
          />
        </Cell>
      )}

      {showAppointments && (
        <Cell span="half">
          <StackedBarChartCard
            type="user_appointment"
            title="Appointments"
            {...sharedProps}
          />
        </Cell>
      )}

      {showApplicationGroup && (
        <Cell span="half">
          <StackedBarChartCard
            type="ticket3"
            title="Maintenance — Technical Staff"
            {...sharedProps}
          />
        </Cell>
      )}

      {showApplicationGroup && (
        <Cell span="half">
          <StackedBarChartCard
            type="ticket4"
            title="Maintenance — Vendors"
            {...sharedProps}
          />
        </Cell>
      )}

      {showTicketChart && (
        <Cell span="full">
          <StackedBarChartCard
            type="ticket"
            title="Maintenance Categories"
            {...sharedProps}
          />
        </Cell>
      )}

      {showProperty && (
        <Cell span="half">
          <StackedBarChartCard
            type="property"
            title="Properties"
            {...sharedProps}
          />
        </Cell>
      )}

      <Cell span="half">
        <StackedBarChartCard type="rent" title="Rent" {...sharedProps} />
      </Cell>

      {showPropertyManager && (
        <Cell span="half">
          <StackedBarChartCard
            type="property_manager"
            title="Property Managers"
            {...sharedProps}
          />
        </Cell>
      )}

      {showLeads && (
        <Cell span="half">
          <StackedBarChartCard
            type="leads"
            title="Leads"
            {...sharedProps}
          />
        </Cell>
      )}
    </div>
  );
};

export default DashboardCharts;
